<template>
  <div>
    <head-nav-bar title="开台" :fixed="true" />
    <div class="mt-header-nav">
      <van-field
        v-model="form.PersonCount"
        type="number"
        clearable
        label="就餐人数"
        autofocus
        id="PersonCount"
      />
      <van-field
        class="my-name"
        v-model="form.Contact"
        clearable
        label="姓名"
        placeholder="请输入姓名"
      />
      <van-field
        v-model="form.Phone"
        type="tel"
        clearable
        label="电话"
        placeholder="请输入电话"
      />
      <form-select
        label="客源"
        v-model="form.GuestSourceId"
        :columns="selectData.ResGuestSource"
      ></form-select>
      <form-select
        label="业务员"
        v-model="form.SalesmanId"
        :columns="selectData.Salesman"
      ></form-select>
      <form-select
        label="客户"
        :columns="selectData.customer"
        v-model="form.CustomerId"
      ></form-select>
      <van-field
        label="会员卡"
        placeholder="请选择会员卡"
        @click="handleMember"
        v-model="form.member.Name"
        right-icon="arrow"
        readonly
      />
      <van-field
        label="备注信息"
        placeholder="请输入备注信息"
        v-model="form.OrderRemark"
        rows="2"
        autosize
        type="textarea"
      />
      <div class="choose-title">选择桌台</div>
      <van-grid :gutter="10" class="table-list">
        <van-grid-item
          v-for="item in tableList"
          :key="item.TableId"
          :text="item.TableName"
          class="table-item "
          :class="{ checked: selectKeys.includes(item.TableId) }"
          @click="chooseTable(item)"
        >
          <template slot="icon">
            <img class="table-img" src="@/assets/images/chair2.png" alt="" />
            {{ item.Seat }}
          </template>
        </van-grid-item>
      </van-grid>
      <van-goods-action>
        <van-goods-action-button
          type="warning"
          text="仅开台"
          :disabled="!selectKeys.length"
          @click="onSubmit(1)"
        />

        <van-goods-action-button
          type="info"
          text="开台点菜"
          :disabled="!selectKeys.length || selectKeys.length > 1"
          @click="onSubmit(2)"
        />
      </van-goods-action>
    </div>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Field,
  Toast,
  Button,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Popup,
  Icon,
  Dialog,
  Grid,
  GridItem,
  Notify,
} from "vant";
import { getSelectData } from "@/api/common.js";
import restaurantManageApi from "@/api/restaurantManage.js";
import formSelect from "@/components/form-select";
import selectMember from "@/components/select-member/function.js";
import { mapState } from "vuex";
export default {
  name: "restOpenTable",
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    formSelect,
  },
  data() {
    return {
      selectData: {},
      form: {
        PersonCount: 1,
        // Contact: "",
        // Phone: "",
        // GuestSourceId: "",
        // CustomerId: "",
        // SalesmanId: "",
        // SalesmanName: "",
        // OrderRemark: "",
        member: {},
      },
      tableList: [],
      selectKeys: [],
    };
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  created() {
    this.$nextTick(() => {
      const el = document.getElementById("PersonCount");
      el.select();
      setTimeout(() => {
        el.focus();
      }, 100);
    });
    this.getSelectData();
    this.getTableInfo();
  },
  methods: {
    getTableInfo() {
      restaurantManageApi.getTableStatus({ OnlyVaild: true }).then(res => {
        this.tableList = res.Data.TableStatusDetails;
        if (this.$route.query.tableId) {
          this.selectKeys.push(this.$route.query.tableId);
        }
      });
    },
    chooseTable(item) {
      if (this.selectKeys.includes(item.TableId)) {
        this.selectKeys = this.selectKeys.filter(el => el != item.TableId);
      } else {
        this.selectKeys.push(item.TableId);
      }
    },
    /**选择会员卡*/
    handleMember() {
      selectMember({
        height: "80%",
        change: info => {
          this.form.member = {
            CardNo: info.CardNo,
            Name: info.Name,
            Id: info.Id,
          };
          if (!this.form.Contact) {
            this.form.Contact = info.Name;
          }
          if (!this.form.Phone) {
            this.form.Phone = info.Phone;
          }
        },
        clear: () => {
          this.form.member = {
            CardNo: "",
            Name: "",
            Id: "",
          };
        },
      });
    },
    onSubmit(type) {
      if (!this.selectKeys || !this.selectKeys.length) {
        Notify("请选择桌台");
        return false;
      }
      const json = {
        ...this.form,
        MemberCardId: this.form.member.Id,
        TableIds: this.selectKeys,
      };
      delete json.member;
      restaurantManageApi.createOrder(json).then(res => {
        Notify({ type: "success", message: "开台成功" });
        if (type === 1) {
          // 仅开台，返回工作台
          this.$router.push({
            name: "restarantManageIndex",
          });
        } else {
          // 开台点菜
          this.$router.push({
            name: "restarantManageOrderFood",
            query: {
              orderId: res.Data.Id,
            },
          });
        }
      });
    },
    getSelectData() {
      const _this = this;
      getSelectData({
        Types: "customer,Salesman,ResGuestSource",
      }).then(res => {
        _this.selectData = res.Data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.select-box /deep/.van-cell {
  .van-field__label {
    width: 2.4rem;
    color: #666;
  }
}
.custom-filed {
  padding: 0;
}
.choose-title {
  padding: 10px;
  background: #fafafa;
  margin-bottom: 10px;
}
/deep/.van-goods-action {
  z-index: 1;
}
.table-list {
  padding-bottom: 10px;
  .table-item {
    /deep/.van-grid-item__content--center {
      border: 1px solid transparent;
    }
    &.checked {
      /deep/.van-grid-item__content--center {
        border: 1px solid #f20;
        background: #fffafa;
      }
    }
  }
}
</style>
